import styles from '@components/Loader/Loader.styles';
import Icon from '@components/icons/Icon';
type PropsType = {
  fullCover?: boolean;
  isLoading?: boolean;
  isTransparent?: boolean;
  isFixed?: boolean;
};
const Loader = ({
  fullCover = false,
  isLoading = true,
  isTransparent = false,
  isFixed = false
}: PropsType) => <div sx={styles.loaderArea(fullCover, isLoading, isTransparent)}>
    <div sx={styles.loader(isFixed)}>
      <Icon icon="Spinner" size="40px" />
    </div>
  </div>;
export default Loader;